define('runTemplateTabsData',[
  'module',
  'underscore'
], function(
  module,
  _
) {
  'use strict';

  module.exports = [{
      name: 'detail',
      title: _.i18n('runs.detail.tabTitle')
    },
    {
      name: 'table',
      title: _.i18n('runs.table.tabTitle')
    },
    {
      name: 'details',
      title: _.i18n('runs.details.tabTitle')
    }
  ];
});
